import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeFill = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9999 4C16.1417 4.00003 20.1618 6.64058 22.6709 11.6649L22.8383 12L22.6709 12.3351C20.1618 17.3595 16.1417 20 11.9999 19.9999C7.8582 19.9999 3.83809 17.3593 1.32896 12.335L1.16162 11.9999L1.32896 11.6648C3.8381 6.64046 7.85821 3.99997 11.9999 4ZM8.37495 12C8.37495 9.99797 9.99791 8.375 11.9999 8.375C14.002 8.375 15.6249 9.99797 15.6249 12C15.6249 14.002 14.002 15.625 11.9999 15.625C9.99791 15.625 8.37495 14.002 8.37495 12Z",
		fill: "currentcolor"
	})]
});
export default SvgEyeFill;
